import React from 'react';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
// Components
import App from '../../../components/app';
import EnhancedTable from '../../../components/table';
// Modules
import { tableRequestPoints } from '../../../redux/reducers/constants';
import { selectors as errorsSelectors, ErrorPayload } from '../../../redux/reducers/errors';
import { actions as companiesActions, selectors as companiesSelectors } from '../../../redux/reducers/companies';
// Ressources
import withGlobalStyles from '../../../utils/global-styles';
import { paths } from '../../paths';
import { connect } from 'react-redux';
import { Company, Industry } from '../../../redux/reducers/api-types';
import ErrorMessage from '../../../components/error-message/error-message';
import { generateOptions } from '../../../utils/businessUtils';
import StringUtils from '../../../utils/stringUtils';
import { getFindUsersURL } from '../../../utils/core-api';
import { FormatType, HeadCell, PickerOption } from '../../../local-types';
import { Cell, createCell } from '../../../components/table/table-cell-creator';

interface CompaniesListPageProps extends WithTranslation {
    globalClasses: any;
    industries: Industry[];
    getIndustriesError: ErrorPayload;
    getCompanyIndustries: () => any;
}

class CompaniesListPage extends React.Component<CompaniesListPageProps> {
    constructor(props: CompaniesListPageProps) {
        super(props);

        if (!props.industries?.length) {
            props.getCompanyIndustries();
        }
    }

    generateIndustryOptions = (): PickerOption[] => {
        const { industries } = this.props;
        return generateOptions(industries, 'id');
    };

    headerBuilder = (): HeadCell[] => {
        const { t } = this.props;
        const headers: HeadCell[] = [
            createCell(t, Cell.ID, { sortable: true }),
            createCell(t, Cell.NAME),
            createCell(t, Cell.CREATION_DATE),
            // {
            //     id: 'total_net_price_without_vat_generated_recently',
            //     label: t('total_net_30'),
            //     filterable: false,
            //     type: FormatType.Price,
            // },
            // {
            //     id: 'total_net_price_without_vat',
            //     label: t('total_net'),
            //     filterable: false,
            //     type: FormatType.Price,
            // },
            { id: 'nb_users', label: t('nb_users'), filterable: false },
            {
                id: 'account_manager.id',
                label: t('account_manager'),
                sortable: false,
                type: FormatType.Autocomplete,
                api: getFindUsersURL(),
                customAlt: (item) => item?.id,
                formatCell: function (row) {
                    const { account_manager } = row;
                    return StringUtils.userFullname(account_manager);
                },
            },
            {
                id: 'industry.id',
                label: t('industry'),
                type: FormatType.Picker,
                pickerOptions: this.generateIndustryOptions(),
                sortable: false,
                formatCell: function (row: Company) {
                    return row.industry?.name;
                },
            },
        ];
        return headers;
    };

    render() {
        const { t, globalClasses, getIndustriesError } = this.props;

        return (
            <App
                disableBreadcrumb
                header={{
                    title: t('title'),
                    subtitle: t('description'),
                }}
            >
                <ErrorMessage payload={getIndustriesError} />
                <EnhancedTable headers={this.headerBuilder()} type={tableRequestPoints.COMPANIES} />
                <br />
                <br />
                <Fab
                    className={globalClasses.fabBotRight}
                    component={RouterLink}
                    to={paths.companiesAdd}
                    color="secondary"
                    aria-label={t('common:add')}
                >
                    <AddIcon />
                </Fab>
            </App>
        );
    }
}

const mapStateToProps = (state) => ({
    industries: companiesSelectors.getIndustries(state),
    getIndustriesError: errorsSelectors.getIndustriesError(state),
});

const mapDispatchToProps = {
    getCompanyIndustries: companiesActions.getCompanyIndustries,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withGlobalStyles(withTranslation(['company', 'common'])(CompaniesListPage)));
